import { useLocalSearchParams } from 'expo-router';

import { ProfileView } from '@/screens/profile-view';

export default function UserProfileRoute() {
  const { userId } = useLocalSearchParams<{ userId: string }>();
  return <ProfileView userId={userId} />;
}
